
import existingRetailMessageTemplate from "../registration/existingRetailMessageTemplate";
import idProofConsentTemplate from "../idProof/idProofConsentTemplate";
import IDProofConsentController from ".././idProof/IDProofConsentController";

var modalInstance;
var accountOpenController = function (
    $scope,
    $state,
    $modal,
    $uibModal,
    otsRegistrationService,
    preAccountOpeningFactory,
    otsAccountOpenFactory,
    $q
) {

    var vm = this;
    vm.isDataLoaded = false;
    vm.countryCodes = [];
    $scope.stateCodes = [];
    $scope.isRegistered = null;
    $scope.loading = false;
    vm.serviceError = false;

    $scope.init = function () {
        var deferred = $q.defer();


        preAccountOpeningFactory.retrieveCountryCode.query({}).$promise.then(
            function (data) {
                if (data !== null) {
                    vm.countryCodes = data.filter(c => c.code == 'US');
                }
                deferred.resolve();
            }, function () {
                deferred.reject();
            });
        preAccountOpeningFactory.retrieveStateCode.query({}).$promise.then(
            function (data) {
                if (data !== null) {
                    $scope.stateCodes = data.filter(codes => {
                        return !["AB", "BC", "BU", "FM","LB","MB","MP","NB","NF","NL","NS","NT","NU","ON","PE","PW","QC","SK","WB","YT"].includes(codes.code)});
                }
                deferred.resolve();
            }, function () {
                deferred.reject();
            });
        return deferred.promise;
    };


    function onInitSuccess() {
        vm.isDataLoaded = true;
    }

    function onInitFailure() {
        vm.isDataLoaded = true;
        vm.serviceError = true;
    }
    
    $scope.formData = otsRegistrationService.getFormData();

    $scope.handlePersonalDetailsFormSubmit = function(data) {
        otsRegistrationService.setFormData(data);
        $scope.formData = otsRegistrationService.getFormData();
        handleRoutingOption();
    }

    $scope.handleDetailsFormSubmit = function (data) {
        otsRegistrationService.setFormData(data);
        $state.go("otsAccountRegistrationB");
    };

    const userRegistrationInformation = function () {
        let {ssn, 
            firstName,
            lastName,
            addressLine1,
            addressLine2,
            city,
            state,
            zipCode,
            dateOfBirth} = otsRegistrationService.getFormData();

        let formatDOB = dateOfBirth.split('/').join('');
        
        let userInfo = {
            "ssn" : ssn,
            "zipCode": zipCode,
            "lastName": lastName,
            "dateOfBirth": formatDOB,
            "firstName": firstName,
            "addressLine1": addressLine1,
            "addressLine2": addressLine2,
            "city": city,
            "stateCode": state,
            "country": "US"
        }

        return userInfo;
    }
    var openConsentModal = function (flowName) {
        modalInstance = $uibModal.open({
            template: idProofConsentTemplate,
            controller: IDProofConsentController,
            controllerAs: 'idProofConsentCtrl',
            size: 'md',
            windowClass: 'modal-wrapper',
            resolve: {
                param: function() {
                    return flowName;
                }
            }
        });
    };

    const handleRoutingOption = function() {

        otsAccountOpenFactory.getExistingUserOTS(userRegistrationInformation()).then(
            function(response) {
                if (response.errors === false) {
                    if (response.state === 'ID_PROOFING_OTP_STATE') {
                        openConsentModal(response.flowName);
                    }else if (response.state === 'STATE_REGISTER_USER') {
                        $scope.isRegistered = false;
                    }else if(response.state === 'STATE_LOGIN_USER') {
                        $scope.isRegistered = true;
                    }
                }
            }
        ).catch(function(error) {
            console.log('An Error occured: ' + error)
        })
    }

    $scope.init().then(onInitSuccess, onInitFailure);
};

accountOpenController.$inject = ['$scope', '$state', '$modal', '$uibModal', 'otsRegistrationService', 'preAccountOpeningFactory','otsAccountOpenFactory', '$q'];
export default accountOpenController;
